class ToggleNav {

  constructor(){
		this.body    = document.querySelector('body');
		this.allTriggers = document.querySelectorAll('[data-toggle-trigger]');

		if(this.allTriggers){
			this._init();
		}
	}

	_init(){

		for (let element of this.allTriggers) {
			element.addEventListener('click', (event)=> this._toggleNav(event, element) );
		}
		window.addEventListener('click', (event)=> this._closeNav() );
	}

	_toggleNav(event, element){
		
		// Stop propagation of close primary nav event
		event.stopPropagation();

		const currentName = element.getAttribute('data-toggle-trigger');
		const triggers = document.querySelectorAll(`[data-toggle-trigger="${currentName}"]`);
		const target  = document.querySelector(`[data-toggle-target="${currentName}"]`);
		const isActive = (target.getAttribute('data-state') === 'open');

		this._closeNav();
		
		if(!isActive){
			this.body.setAttribute('data-state', 'locked-for-header-primary');
			target.setAttribute('data-state', 'open');
	
			for (let element of triggers) {
				element.setAttribute('data-state', 'open');
			}
			
			this._toggleKeyboardListener(target);
		}
		
	}

	_toggleState(elem, one, two){
		const newState = elem.getAttribute('data-state') === one ? two : one;
  	elem.setAttribute('data-state', newState);
	}
	
	_closeNav(){
		const targets  = document.querySelectorAll(`[data-toggle-target][data-state="open"]`);
		for (let element of targets) {

			this.body.removeAttribute('data-state');
			element.setAttribute('data-state', 'closed');
			
			for (let element of this.allTriggers) {
				element.setAttribute('data-state', 'closed');
			}

			document.removeEventListener('keydown', this.functionReference);
		}
	}

	_toggleKeyboardListener(target){
		const isActive = (target.getAttribute('data-state') === 'open');
		
		if(isActive){
			this.functionReference = this._onKeyDown.bind(this);
			document.addEventListener('keydown', this.functionReference);
		} else {
			document.removeEventListener('keydown', this.functionReference);
		}
	}

	_onKeyDown(e){
		switch (e.keyCode) {
			case 27:
			this._closeNav();
			break;
			default:
			break;
		}
	}

}

export let toggleNav = new ToggleNav();